import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import Invoices from "@/components/invoices";

const InvoicesPage = () => {
  return (
    <PageLayout title="Payout reports">
      <Invoices />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "InvoicesPage" })(InvoicesPage);
